import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Accueil" },
    { path: "/services", label: "Services" },
    { path: "/processus", label: "Processus" },
    { path: "/a-propos", label: "À propos" },
    { path: "/entretien", label: "Entretien" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-200" data-testid="navigation-header">
      <div className="container-custom">
        <nav className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <div className="flex flex-col">
              <span className="heading-playfair text-xl md:text-2xl lg:text-3xl font-semibold text-slate-900 leading-tight">
                Sourires Saint-Bruno
              </span>
              <span className="text-lato text-sm md:text-base text-slate-500 tracking-wide">
                Denturologistes
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.replace("/", "") || "home"}`}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive(link.path)
                    ? "text-slate-900 bg-stone-100"
                    : "text-slate-600 hover:text-slate-900 hover:bg-stone-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:450-441-3636"
              className="btn-call text-sm"
              data-testid="nav-call-button"
            >
              <Phone className="w-4 h-4" />
              <span>450-441-3636</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-button"
            aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </nav>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-stone-200" data-testid="mobile-menu">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.path.replace("/", "") || "home"}`}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-3 text-base font-medium rounded-lg transition-colors ${
                    isActive(link.path)
                      ? "text-slate-900 bg-stone-100"
                      : "text-slate-600 hover:text-slate-900 hover:bg-stone-50"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:450-441-3636"
                className="btn-call mt-4 justify-center"
                data-testid="mobile-call-button-nav"
              >
                <Phone className="w-4 h-4" />
                <span>Appelez-nous</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navigation;
